import { ConfigurableColumnsKeys, IEntityDto, Nullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { IPropertyInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";

export interface IPaperDimensionDto
{
    height: number;
    width: number;
}

export interface IPrintReportTemplateDto extends IEntityDto
{
    name: string;
    description: string;
    definition: string;
}

export enum GraphicsUnitEnum
{
    pixel = "pixel",
    point = "point",
}

export interface IFontDefinition
{
    bold: boolean;
    family: string;
    italic: boolean;
    size: number;
    strikeout: boolean;
    graphicsUnit: GraphicsUnitEnum;
    underline: boolean;
    sizeInPoints: number;
}

export interface IReportMarginDefinition
{
    bottom: number;
    left: number;
    right: number;
    top: number;
}

export interface IReportElementDefinition
{
    $type?: Nullable<string>;

    id: string;
    name?: Nullable<string>;

    bottom: number;
    left: number;
    right: number;
    top: number;
}

export enum LineStyleEnum
{
    none = "none",
    single = "single",
    double = "double",
    dotted = "dotted",
    dashed = "dashed",
    dashSmallGap = "dashSmallGap",
    dotDash = "dotDash",
    dotDotDash = "dotDotDash"
}

export interface IDrawingElementDefinition extends IReportElementDefinition
{
    endSectionId: string;
    lineColor: string;
    lineStyle: LineStyleEnum;
    lineThickness: number;
}

export interface IReportSectionDefinition
{
    backgroundColor?: string;
    backgroundColorFormula?: string;
    backgroundColorFormulaEvaluator?: any;
    disabled?: boolean;
    height: number;
    id?: string;
    newPageAfter?: boolean;
    newPageBefore?: boolean;
    splitAcrossPages?: boolean;
    reportElements: IReportElementDefinition[];
}

export interface IReportAreaDefinition
{
    disabled?: boolean;
    height?: number;
    id?: string;
    newPageAfter?: boolean;
    newPageBefore?: boolean;
    reportSections: IReportSectionDefinition[];
}

export enum PaperOrientationEnum
{
    portrait = "portrait",
    landscape = "landscape",
}

export enum PaperSizeEnum
{
    a2 = "a2",
    a3 = "a3",
    a4 = "a4",
    a5 = "a5",
    a6 = "a6",
    b4 = "b4",
    b5 = "b5",
    custom = "custom",
    envelopeDL = "envelopeDL",
    envelopeC5 = "envelopeC5",
    executive = "executive",
    legal = "legal",
    letter = "letter",
    paper11x17 = "paper11x17",
}

export interface IReportGroupDefinition
{
    id: string;
    dataSourceFieldName: string;
    footer: IReportAreaDefinition;
    header: IReportAreaDefinition;
}

export type ReportTemplateDefinitionReportAreaKeys = ConfigurableColumnsKeys<IReportTemplateDefinition, IReportAreaDefinition>;

export interface IReportTemplateDefinition
{
    defaultColor?: string;
    defaultFont?: IFontDefinition;
    id?: string;
    margin: IReportMarginDefinition;
    pageFooter: IReportAreaDefinition;
    pageHeader: IReportAreaDefinition;
    paperOrientation: PaperOrientationEnum;
    paperSize: PaperSizeEnum;
    detail: IReportAreaDefinition;
    reportFooter: IReportAreaDefinition;
    reportGroups: IReportGroupDefinition[];
    reportHeader: IReportAreaDefinition;
    storedProcedureName: Nullable<string>;
    storedProcedureProperties: Nullable<IPropertyInfoMetadata[]>;
}